import { render, staticRenderFns } from "./rankingCoachs.vue?vue&type=template&id=44f7c7a4&"
import script from "./rankingCoachs.vue?vue&type=script&lang=js&"
export * from "./rankingCoachs.vue?vue&type=script&lang=js&"
import style0 from "./rankingCoachs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
